<template>
  <b-navbar
    toggleable="lg"
    type="light"
    variant="white"
    :fixed="fixed ? 'top' : null"
    class="main-navbar"
  >
    <b-container>
      <b-navbar-brand
        :href="currentRoute.name !== 'home' ? `../../#inicio` : '#inicio'"
      >
        <img :src="require('@/assets/estudio9-logo.svg')" alt="Logo estudio9" />
        <h1 class="h6 font-weight-light color-darken-1 d-none d-sm-block">
          Creamos espacios que combinan decisiones estéticas, técnicas,
          funcionales, económicas y legales, logrando un equilibrio armónico que
          permiten el desarrollo de la actividad humana, proyectando a la persona
          y sus metas.
        </h1>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="d-flex justify-content-end w-100">
          <li
            v-for="(link, i) in links"
            :key="`${link.name}-${i}`"
            class="nav-item font-weight-bold ml-3"
          >
            <a
              @click="
                currentRoute.name !== 'home'
                  ? $router.push({ name: 'home' })
                  : ''
              "
              :href="
                currentRoute.name !== 'home' ? `../../${link.path}` : link.path
              "
              :class="[
                'nav-link',
                currentRoute.fullPath === link.path ? 'active' : ''
              ]"
              v-smooth-scroll="{
                duration: 500,
                offset: -140,
                container: '#main',
                updateHistory: false
              }"
            >
              {{ link.name }}
            </a>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  props: {
    fixed: Boolean
  },
  data() {
    return {
      hideBar: false,
      links: [
        { name: "Inicio", path: "#inicio" },
        { name: "Nosotros", path: "#nosotros" },
        { name: "Equipo", path: "#equipo" },
        { name: "Servicios", path: "#servicios" },
        { name: "Proyectos", path: "#proyectos" },
        // { name: "Noticias", path: "#noticias" },
        { name: "Contacto", path: "#contacto" }
      ]
    };
  },
  computed: {
    currentRoute() {
      return this.$route;
    }
  }
};
</script>

<style scoped lang="sass">
.main-navbar
  min-height: 94px
  padding: 1rem
  box-shadow: 0 16px 16px rgba( black, 0.04)
  top: calc(100vh - 94px)
  transition: min-height 500ms ease
  align-items: baseline
  &:not(.fixed-top)
    min-height: 170px
    width: 100%
    position: absolute
    top: calc(100vh - 170px)
    transition: min-height 300ms ease
    .navbar-brand
      max-width: 40%
      img
        margin-bottom: 1rem
        opacity: 1
      h1
        opacity: 1
        height: 50px
        transition: all 300ms ease
    .nav-item
      font-size: 14px
      transition: font-size 150ms ease
  &.fixed-top
    top: 0
  .navbar-brand
    width: min-content
    min-height: 65px
    display: flex
    flex-direction: column
    align-items: baseline
    justify-content: center
    img
      height: 44px
      opacity: 0.7
    h1
      opacity: 0
      height: 0
      transition: all 300ms ease
      white-space: normal
      overflow: hidden
      font-size: 14px
  .nav-item, a
    transition: font-size 300ms ease
    &:focus
      outline: none
  .navbar-toggler
    border: unset
    // border-radius: 50%
    outline: unset
  @media screen and (max-width: 502px)
    min-height: unset
    padding: 1rem
    .nav-item, a
      font-weight: 500
    .navbar-collapse
      padding: 1rem
      letter-spacing: 2px
</style>
